/* eslint-disable @typescript-eslint/no-this-alias */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { ref } from "vue"; // Import ref from Vue

import {
  localKey,
  localOffset,
  localPagination,
  localSidebarKey,
  localStateFilter,
  localization,
} from "@/dto/local.key.dto";
import { apiKey } from "@/dto/api.key.dto";
import { sidebars } from "@/json/menus/sidebar.json";
import { globals } from "@/main";

// start interface
interface ResponseData {
  [key: string]: string;
}

interface AnyObject {
  [key: string]: any;
}
interface AnyObjectError {
  error?: string[];
}

interface SidebarState {
  width: string;
  data: any[];
}

// end interface

// start access token and refresh token
const getAccessTokenFromLocalStorage = (): string => {
  const storedAccessToken = localStorage.getItem(localKey?.accessToken);
  if (storedAccessToken && storedAccessToken !== "undefined") {
    return storedAccessToken;
  } else {
    return "";
  }
};

const getRefreshTokenFromLocalStorage = (): string => {
  const storedRefreshToken = localStorage.getItem(localKey?.refreshToken);
  if (storedRefreshToken && storedRefreshToken !== "undefined") {
    return storedRefreshToken;
  } else {
    return "";
  }
};

const getI18n = (): string => {
  const locale = localStorage.getItem(localization);
  if (locale && locale !== "undefined") {
    return locale;
  } else {
    return "en";
  }
};

export const setAccessAndRefreshToken = (response: ResponseData): void => {
  const accessTK = response[apiKey?.accessToken];
  const refreshTK = response[apiKey?.refreshToken];

  if (accessTK && refreshTK) {
    localStorage.setItem(localKey.accessToken, accessTK);
    localStorage.setItem(localKey.refreshToken, refreshTK);

    accessToken.value = accessTK;
    refreshToken.value = refreshTK;
  }
};

export const accessToken = ref(getAccessTokenFromLocalStorage());
export const refreshToken = ref(getRefreshTokenFromLocalStorage());
export const i18nLocale = ref(getI18n());
// end access token and refresh token

export const bindingSchema = (object: AnyObjectError = {}): string => {
  if (object?.error && object?.error.length > 0) {
    return object.error[0];
  } else {
    return "";
  }
};

const isEmpty = (value: any): boolean => {
  return value === null || value === undefined || value === "";
};

const errorEmptyBody = (obj: AnyObject): AnyObject => {
  return Object.keys(obj).length === 0 ? {} : obj;
};

export const errors = (object: AnyObject = {}): AnyObject => {
  for (const prop in object) {
    if (
      Object.prototype.hasOwnProperty.call(object, prop) &&
      isEmpty(object[prop])
    ) {
      delete object[prop];
    }
  }

  return errorEmptyBody(object);
};

export const setSidebars = (): SidebarState => {
  const width = localStorage.getItem(localSidebarKey);
  if (!width) {
    localStorage.setItem(localSidebarKey, "fix-sidebar");
  }

  return {
    width: width || "fix-sidebar",
    data: sidebars,
  };
};

export const getSidebars = ref(setSidebars());

export const findEnumEntry = <T>(
  enumArray: Array<T>,
  value: string | number
): T | "Unknown" => {
  const result = enumArray.find((element: T) => {
    return (element as any).value === value;
  });

  if (result) {
    return result;
  } else {
    return "Unknown";
  }
};

export const getEnum = (arr: any, value: string | number) => {
  const result = arr.find((element: any) => {
    return (element as any).value === value;
  });

  if (result) {
    return result?.label || result;
  } else {
    return "Unknown";
  }
};

export const formatPrice = (price: number) => {
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  return price ? formatter.format(price) : formatter.format(0);
};

export const formatNumber = (number: number | null) => {
  if (number == null) return "0";

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatPhoneNumber = (data: string | null, isPlace = false) => {
  if (!data || isNaN(Number(data))) {
    return isPlace ? "" : "N/A";
  }

  const phoneNumber = data.replace("+8550", "0").replace("+855", "0");
  let phone = phoneNumber.split("") || data.split("");

  if (phone[0] !== "0") {
    phone = ["0"].concat(phone);
  }

  const countIndex = [
    phone.slice(0, 3).join(""),
    phone.slice(3, 6).join(""),
    phone.slice(6, 9).concat(phone.slice(9)).join(""),
  ].filter((item) => item.length > 0);

  return isPlace ? countIndex.join("") : countIndex.join(" ");
};

export const formatPhoneCode = (phoneNumber: string) => {
  if (!phoneNumber || isNaN(Number(phoneNumber))) {
    return "N/A";
  }
  return `+885 ${formatPhoneNumber(phoneNumber, false)}`;
};

export const formatDate = (
  date: Date | null,
  format = "DD MMM YYYY | hh:mm A"
) => {
  return (date && globals.$moment(date).format(format)) || "N/A";
};

export const tableFormatDate = (
  date: Date | null,
  format = "DD MMM YYYY | hh:mm A"
) => {
  // return (date && globals.$moment.utc(date).format(format)) || "N/A";
  if (!date) {
    return "N/A";
  }

  const newDate = `<span class="format-date">
    <span class="show-less-date">${globals
      .$moment(date)
      .format("DD MMM YYYY")}</span>
    <span class="show-full-date">${globals.$moment(date).format(format)}</span>
  </span>`;
  return newDate;
};

export const tableFormatDateFixed = (
  date: Date | null,
  format = "DD MMM YYYY | hh:mm A"
) => {
  // return (date && globals.$moment.utc(date).format(format)) || "N/A";
  if (!date) {
    return "N/A";
  }

  const newDate = ` <span class="show-full-date-fixed">${globals
    .$moment(date)
    .format(format)}</span>`;
  return newDate;
};

export const tableDisplayDescription = (description: string) => {
  if (!description) {
    return "N/A";
  }

  const newDescription = `<span class="format-description">
    <span class="show-less-description">${description}</span>
    <span class="show-full-description">${description}</span>
  </span>`;
  return newDescription;
};

export const formatDateISOString = (date: Date, minutes = 15) => {
  const startingDate = globals.$moment(date);
  const currentTime = globals.$moment();
  const targetTime = currentTime.add(minutes, "minutes");
  const targetDateTime = globals.$moment(
    startingDate.format("YYYY-MM-DD") + " " + targetTime.format("HH:mm:ss")
  );
  const isoString = targetDateTime.toISOString();

  return isoString;
};

export const startOfDay = (date?: Date | string) =>
  globals.$moment(date).startOf("day").toISOString();
export const endOfDay = (date?: Date | string) =>
  globals.$moment(date).endOf("day").toISOString();
export const startOfMonth = (date: Date | string) =>
  globals.$moment(date).startOf("month").toISOString();

export const getFullImage = (path: string): string => {
  if (!path) {
    return "";
  }

  const pathString = String(path);

  if (pathString.startsWith("http://") || pathString.startsWith("https://")) {
    return pathString;
  }

  const fullImagePath = `${process.env.VUE_APP_BASE_URL_IMAGE}/${pathString}`;
  return fullImagePath;
};

export const queryParams = (obj: { [key: string]: any }) => {
  const queries = Object.entries(obj)
    .filter(
      ([key, value]) => value !== undefined && value !== null && value !== ""
    )
    .flatMap(([key, value]) => {
      if (Array.isArray(value)) {
        // For array, return multiple query params with the same key
        return value.map(
          (val) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
        );
      }
      // Otherwise return a single key=value pair
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join("&");

  return queries ? "?" + queries : "";
};

export const limitQuery = (): number => {
  // return parseInt(localStorage.getItem(localPagination) || "10", 10);
  return 10;
};

export const offsetQuery = (): number => {
  return parseInt(localStorage.getItem(localOffset) || "0", 0);
};

export const getStateFilter = (filter: any): any => {
  return localStorage.getItem(localStateFilter) ? filter : filter;
};

export const setStateFilter = (filter: any): any => {
  return localStorage.setItem(localStateFilter, JSON.stringify(filter));
};

// {{ $psm("VIEW_CUSTOMER") }}
export const permissionQuery = (permission: string): boolean => {
  const permissions = globals.$store.state.permissions;
  const hasPermission = permissions.some((item: string) => item === permission);

  return hasPermission;
};

export const setCurrentPath = (
  data: { children?: Child[] }[]
): CurrentRoute[] => {
  const routes: CurrentRoute[] = [];
  const types: CurrentRoute[] = [];

  data.forEach((route) => {
    const typedRoute = route as any;

    types.push({
      url: typedRoute?.adminRouteUrl || "",
      endpoint: typedRoute?.apiUrl || "",
      method: typedRoute?.apiMethod || "",
      param: typedRoute?.param || {},
      payload: typedRoute?.payload || {},
      name: typedRoute?.adminRouteName || "",
      code: typedRoute?.code || "",
      en: typedRoute?.title || "",
      km: typedRoute?.titleForeign || "",
    });

    if (route.children) {
      route.children.forEach((child) => {
        const url = child?.adminRouteUrl || "";
        const endpoint = child?.apiUrl || "";
        const method = child?.apiMethod || "";
        const param = child?.param || {};
        const payload = child?.payload || {};
        const name = child?.adminRouteName || "";
        const code = child?.code || "";
        const en = child?.title || "";
        const km = child?.titleForeign || "";

        routes.push({
          url,
          endpoint,
          method,
          param,
          payload,
          name,
          code,
          en,
          km,
        });
      });
    }
  });

  globals.$store.commit("storeListSubSidebar", types);

  return routes;
};

export const createDynamicApi = (
  endpoints: Endpoint[]
): Record<string, string> => {
  const dynamicApi: Record<string, string> = {};

  endpoints.forEach((endpoint) => {
    const endpointsArray = endpoint.endpoint.split(",").map((e) => e.trim());

    if (endpointsArray.length == 2) {
      if (endpoint.name.startsWith("detail")) {
        const listName = "view" + endpoint.name.substr("detail".length);
        dynamicApi[listName] = endpointsArray[0].trim();
        dynamicApi[endpoint.name] = endpointsArray[1].trim();
      }
    } else {
      dynamicApi[endpoint.name] = endpoint.endpoint;
    }
  });

  return dynamicApi;
};

export const deleteSegment = (url: string): string => {
  return url.replace(/:[^/]+/g, "");
};

export const formatCode = (code: string) => {
  return `<span class="txt-copied">#${code}</span>`;
};

export const formatStatusCode = (code: number) => {
  return code === 1
    ? `
      <span class="badge-success">
        <span class="txt-success mr5 font18">&#x2022;</span>
        <span class="txt-success">${globals.$t("componentActive")}</span>
      </span>
    `
    : `
      <span class="badge-danger">
        <span class="txt-danger mr5 font18">&#x2022;</span>
        <span class="txt-danger">${globals.$t("componentInactive")}</span>
      </span>
    `;
};

export const calculateOffset = (page: number, limit: number) => {
  return (page - 1) * limit;
};

export function debounce<T extends (...args: any[]) => any>(
  func: T,
  wait: number,
  immediate?: boolean
): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout> | null;

  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;

    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

export const getMode = () => {
  return localStorage.getItem("applicationMode") || "light-mode";
};

export const changeMode = () => {
  const newMode = getMode() === "light-mode" ? "dark-mode" : "light-mode";
  localStorage.setItem("applicationMode", newMode);
};

export const mapEnum = (
  val: number | string,
  arrObj: Record<string, any>,
  key = "value",
  label = "label",
  color = "color",
  bg = "bg"
): string => {
  const item = arrObj.find(
    (item: { [x: string]: string | number }) => item[key] === val
  );
  return item
    ? `
      <span class="${item[bg]}">
        <span class="${item[color]} mr5 font18">&#x2022;</span>
        <span class="${item[color]}">${item[label]}</span>
      </span>
    `
    : `N/A`;
};

export const mapFilter = (filtersArray: any[]): Record<string, any> => {
  return filtersArray && filtersArray.length
    ? filtersArray.reduce((acc, filter) => {
        acc[filter.key] = filter.value;
        return acc;
      }, {} as Record<string, any>)
    : [];
};

import packageJson from "../../../package.json";

export const defaultVersion = () => {
  return packageJson.version;
};
